import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { catchError } from "rxjs/operators";
import { ApiConstant } from "src/app/constants/app.constant";
import { ErrorHandlers } from "src/app/utilities/error.handlers";
import { IGetDefault } from "../../../metadata/interfaces/dashboard/interface";
import { ApiModel } from "../../../models/api.model";
import { IResp } from "src/app/metadata/interfaces/IResp";
import { CACHE_KEYs, CacheSystem } from "src/app/utilities/cache.system";

@Injectable({
  providedIn: "root",
})
export class DefaultService {
  constructor(private _Http: HttpClient) {}

  //#region default dashboard services
    async GetDefault(_ApYear?): Promise<IResp> {
      let result: any;
      try {
        const resp = await this.GetDefaultFromAPI(_ApYear);
        if (resp._Status) {
          result = resp._Data;
          CacheSystem.CacheData(CACHE_KEYs.DASHBOARD_DEFAULT, resp._Data);
        }
        return {
          _Status: true,
          _Data: result || null,
          _ErrorCode: 0,
        };
      } catch (error: any) {
        return {
          _Status: false,
          _Data: null,
          _ErrorCode: 500,
        };
      }
    }
  
    async GetDefaultFromAPI(_ApYear?): Promise<IResp>{
      return {
        _Status: true,
        _Data: defaultMock,
        _ErrorCode: 0,
      };
      let url = `${ApiConstant.baseUrlV2}defaultstatistics/CallDefaultstatCache`;
  
      try {
        const response = await this._Http.get<ApiModel<IGetDefault>>(url).toPromise();
        return {
          _Status: true,
          _Data: response,
          _ErrorCode: 0,
        };
      } catch (error: any) {
        return {
          _Status: false,
          _Data: error.message || "An unknown error occurred",
          _ErrorCode: 500,
        };
      }
    }
  //#endregion
  
}

export const defaultMock = {
  _Totalweekvalue: 0,
  _DoorScheduler: {
    _SchedulerCount: 0,
    _SchedulerInUsed: 0,
  },
  _TimeZonesShifts: {
    _Count: 0,
    _InUsed: 0,
  },
  _APIs: {
    _Count: 0,
    _InUsed: 0,
  },
  _SystemEvents: {
    _Count: 0,
    _InUsed: 0,
  },
  _ExtendedServices: {
    _Count: 0,
    _InUsed: 0,
  },
  _StatusChanged: {
    _Pms: "2/15/2022 4:55:49 AM",
    _Service: "2/15/2022 4:55:49 AM",
    _Cloud: "2/15/2022 4:55:49 AM",
    _Api: "2/15/2022 4:55:49 AM",
  },
  _EncodedDefault: {
    _Count: 0,
    _Connected: 0,
    _UnConnected: 0,
    _StatusChange: "2/15/2022 4:55:49 AM",
  },
  _APDefault: {
    _Count: 0,
    _Connected: 0,
    _UnConnected: 0,
    _StatusChange: "2/15/2022 4:55:49 AM",
  },
  _DoorDefault: {
    _Count: 0,
    _Connected: 0,
    _UnConnected: 0,
    _StatusChange: "2/15/2022 4:55:49 AM",
  },
  _PmsCom: {
    _Jan: 0,
    _Feb: 0,
    _Mar: 0,
    _Apr: 0,
    _May: 0,
    _Jun: 0,
    _Jul: 0,
    _Aug: 0,
    _Sep: 0,
    _Oct: 0,
    _Nov: 0,
    _Dec: 0,
  },
  _Success: null,
  _Failed: null,
  _AccessPoints: [
    {
      _Month: "Jan",
      _Success: 0,
      _Failed: 0,
    },
    {
      _Month: "Feb",
      _Success: 0,
      _Failed: 0,
    },
    {
      _Month: "Mar",
      _Success: 0,
      _Failed: 0,
    },
    {
      _Month: "Apr",
      _Success: 0,
      _Failed: 0,
    },
    {
      _Month: "May",
      _Success: 0,
      _Failed: 0,
    },
    {
      _Month: "Jun",
      _Success: 0,
      _Failed: 0,
    },
    {
      _Month: "Jul",
      _Success: 0,
      _Failed: 0,
    },
    {
      _Month: "Aug",
      _Success: 0,
      _Failed: 0,
    },
    {
      _Month: "Sep",
      _Success: 0,
      _Failed: 0,
    },
    {
      _Month: "Oct",
      _Success: 0,
      _Failed: 0,
    },
    {
      _Month: "Nov",
      _Success: 0,
      _Failed: 0,
    },
    {
      _Month: "Dec",
      _Success: 0,
      _Failed: 0,
    },
  ],
  _NewcurrentWeekOpenings: [
    {
      _Day: "Sun",
      _Value: 0,
    },
    {
      _Day: "Mon",
      _Value: 0,
    },
    {
      _Day: "Tue",
      _Value: 0,
    },
    {
      _Day: "Wed",
      _Value: 0,
    },
    {
      _Day: "Thur",
      _Value: 0,
    },
    {
      _Day: "Fri",
      _Value: 0,
    },
    {
      _Day: "Sat",
      _Value: 0,
    },
  ],
  _CurrentWeekOpenings: null,
    _AccessManagement: {
    _TotalAccessRight: 0,
    _TotalAccessProfile: 0,
    _TotalAccessCards: 0,
    _TotalEmployee: 0,
  },
  _AccessManagementChart: [
    {
      _Access: "AR",
      _Visit: 0,
    },
    {
      _Access: "AP",
      _Visit: 0,
    },
    {
      _Access: "ACC",
      _Visit: 0,
    },
    {
      _Access: "PERS",
      _Visit: 0,
    },
  ],
};
